import React, { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, Typography } from '@material-ui/core';
import { createStyles, withStyles, Theme, WithStyles } from '@material-ui/core/styles';

import { PublicUserProfile } from 'api';
import { getFullName } from 'helpers';
import { generateLink } from 'Links';

interface IProps extends WithStyles<typeof styles> {
  profile: PublicUserProfile;
}

const styles = (theme: Theme) =>
  createStyles({
    type: {
      color: theme.custom.palette.orange,
    },
    body: {
      color: theme.custom.palette.grey2,
    },
  });

const ProfileResult: FC<IProps> = ({ classes, profile }) => {
  const { t } = useTranslation();

  return (
    <Fragment>
      <Typography variant="subtitle2">
        <span className={classes.type}>{t('search:profile')} </span>
        <Link component={generateLink(`/profile/${profile.id}`)}>{getFullName(profile)}</Link>
      </Typography>
      <Typography variant="subtitle2" className={classes.body}>
        {t('components:xFollower', { count: profile.follower_count })}
        {profile.department_title && (
          <Fragment>{t('search:department', { title: profile.department_title })}</Fragment>
        )}
        {profile.location_title && (
          <Fragment>{t('search:location', { title: profile.location_title })}</Fragment>
        )}
      </Typography>
    </Fragment>
  );
};

export default withStyles(styles)(ProfileResult);
